import { getPropsFromUrl } from 'components/hoc';
import { Panel } from 'components/ui';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { reset as nameReset } from 'views/ReportFilters/flow/actions';
import { resetCriteria } from 'components/page/FilterCriteria__REFACTORED/flow/actions';
import { resetSelectedCols } from 'views/ReportSetup/flow/actions';
import { FilterInfo, UserInfo, Table } from '../components';
import { tryFetchReportSettingsById } from '../flow/actions';

const defaultProps = {
  tryFetchReportSettingsById: null
};
const propTypes = {
  reportId: PropTypes.string.isRequired,
  tryFetchReportSettingsById: PropTypes.func,
  filterInfo: PropTypes.object.isRequired,
  userInfo: PropTypes.object.isRequired,
  fieldsMetaData: PropTypes.array.isRequired
};

class RealTimeReport extends PureComponent {
  componentDidMount() {
    const { reportId, tryFetchReportSettingsById } = this.props;
    tryFetchReportSettingsById(reportId);
  }
  componentWillUnmount() {
    const { nameReset, resetCriteria, resetSelectedCols } = this.props;
    nameReset();
    resetCriteria();
    resetSelectedCols();
  }

  render() {
    const { filterInfo, userInfo, fieldsMetaData } = this.props;
    return (
      <Panel contentClasses="pt-lg pr-lg pb-lg pl-lg">
        <UserInfo {...userInfo} />
        <div className="pb-lg" />
        <FilterInfo {...filterInfo} {...userInfo} fieldsMetaData={fieldsMetaData} />
        <div className="pb-md" />
        <Table fieldsMetaData={fieldsMetaData} />
      </Panel>
    );
  }
}

const mapStateToProps = ({
  global,
  loginUser,
  realTimeReport,
  reportSetup
}) => ({
  lang: global.language,
  userInfo: {
    name: loginUser.name,
    companyName: loginUser.company.name,
    createdOn: realTimeReport.rawData.createdOn
  },
  filterInfo: {
    filters: realTimeReport.info.settings.filters,
    logic: realTimeReport.info.settings.logic
  },
  fieldsMetaData: reportSetup.sider.availableColumns
});
const mapDispatchToProps = {
  tryFetchReportSettingsById,
  nameReset,
  resetCriteria,
  resetSelectedCols
};
RealTimeReport.defaultProps = defaultProps;
RealTimeReport.propTypes = propTypes;
export default getPropsFromUrl(['reportId'])(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(RealTimeReport)
);



// WEBPACK FOOTER //
// ./src/views/RealTimeReport/container/index.jsx